import request from "@/api";

export function listCustomer(data) {
    return request({
        url: '/api/customer/getCustomerList',
        method: 'get',
        params: data
    })
}
export function listCustomerCache(data) {
    return request({
        url: '/api/customer/getCustomerCacheList',
        method: 'get',
        params: data
    })
}

export function getCustomerInfo(data) {
    return request({
        url: '/api/customer/getCustomerInfo',
        method: 'get',
        params: data
    })
}

export function saveCustomer(data) {
    return request({
        url: '/api/customer/saveCustomer',
        method: 'post',
        data: data
    })
}

export function deleteCustomer(data) {
    return request({
        url: '/api/customer/deleteCustomer',
        method: 'post',
        data: data
    })
}
